export const formatoFechaTabla = (time) => {

    if (!time){
        return ''
    }

    let date = new Date(time)

    if (!date){
        return ''
    }

    // const days = ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab']
    const months = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']

    let dia = date.getDate();
    let mes = date.getMonth();
    let year = date.getFullYear() - 2000;
    let hora = date.getHours();
    let minutos = date.getMinutes();

    if (minutos < 10) {
        minutos = '0' + minutos
    }

    // let hora = date.getHours() + ":" + date.getMinutes();

    let texto = dia + " " + months[mes] + " " + year + ' Hrs ' + hora + ':' + minutos

    return texto


}